class ValidateMimeType {
    private static base64String: string;
    private static signatures: {[index: string]:string} = {
        JVBERi0: "application/pdf",
        R0lGODdh: "image/gif",
        R0lGODlh: "image/gif",
        iVBORw0KGgo: "image/png",
        UklGR: "image/webp",
        "/9j/": "image/jpg"
    };

    constructor() {
        throw new Error("Cannot call a class as a function. Use of() instead.");
    }

    static of(base64String: any) {

        if (Array.isArray(base64String) === true) {
            base64String.forEach((content: string) => {
                this.base64String = content;
                let result: boolean = this.validate();

                if (result === false) {
                    return false;
                }
            });

            return true;
        }
        
        this.base64String = base64String;
        return this.validate();
    }

    static getMimeType(base64String: string) {
        if (Array.isArray(base64String) === true) {
            this.base64String = base64String[0];
        } else {
            this.base64String = base64String;
        }
        
        return this.checkMimeType();
    }

    private static validate(): boolean {
        let result: boolean = false;

        for (const key in this.signatures) {
            if (this.base64String.startsWith(key) === true) {
                result = true;
            }
        }

        return result;
    };

    private static checkMimeType(): string {
        let result: string = "";

        for (const key in this.signatures) {
            if (this.base64String.startsWith(key) === true) {
                switch (this.signatures[key]) {
                    case "application/pdf":
                        result = "pdf";
                        break;
                    case "image/gif":
                        result = "gif";
                        break;
                    case "image/png":
                        result = "png";
                        break;
                    case "image/webp":
                        result = "webp";
                        break;
                    case "image/jpg":
                        result = "jpg";
                        break;
                }
            }
        }

        return result;
    }
}

//removeIf(production)
export default ValidateMimeType;
//endRemoveIf(production)